var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessageFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 7.116 6.829",
    height: 25.811,
    width: 26.896,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      clipRule: "evenodd",
      fill: "#5b5c63",
      fillRule: "evenodd"
    },
    d: "M8.079 15.135h5.815Z",
    transform: "matrix(.26458 0 0 .26458 -4.365 .533)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      clipRule: "evenodd",
      fill: "#fff",
      fillRule: "evenodd"
    },
    d: "M10.105 19.514h7.753z",
    transform: "matrix(.26458 0 0 .26458 .104 -.203)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#1e208d"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.26458 0 0 .26458 .936 .95)",
    d: "M9.91-3.594c-4.841 0-8.237.76-10.437 2.867-2.2 2.107-3.01 5.392-3.01 10.038 0 4.645.81 7.932 3.01 10.039 2.2 2.106 5.596 2.867 10.437 2.867 4.842 0 8.24-.76 10.44-2.867 2.2-2.107 3.01-5.394 3.01-10.04 0-4.645-.81-7.93-3.01-10.037-2.2-2.106-5.598-2.867-10.44-2.867ZM2.451 4.621a.75.75 0 0 1 .592.275s1.049 1.246 2.473 2.487c1.423 1.24 3.256 2.383 4.41 2.383 1.155 0 2.973-1.14 4.385-2.381 1.411-1.24 2.449-2.487 2.449-2.487a.75.75 0 1 1 1.152.961s-1.1 1.323-2.611 2.65c-1.511 1.329-3.4 2.757-5.375 2.757S6.054 9.839 4.53 8.512c-1.522-1.328-2.636-2.65-2.636-2.65a.75.75 0 0 1 .556-1.24Z",
    style: {
      color: "#000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontFeatureSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textOrientation: "mixed",
      dominantBaseline: "auto",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      shapePadding: 0,
      clipRule: "evenodd",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      vectorEffect: "none",
      fill: "#1e208d",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1.49998105,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto",
      enableBackground: "accumulate"
    }
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageFilled);
export default __webpack_public_path__ + "static/media/message-filled.e74821bd17ffc3d7a5aa3dda3bdbc526.svg";
export { ForwardRef as ReactComponent };